import {overtimeConstants} from './OvertimeConstants';

export const getOTSkillsResponse = (payload) => ({   
  type: overtimeConstants.GET_OT_SKILLS_DATA,
  payload
});

export const getOTSkillsDataSuccess = (payload) => ({
  type: overtimeConstants.GET_OT_SKILLS_SUCCESS,
  payload
});